import { Record } from 'immutable';

export default class AvailableDateSettingRecord extends Record({
  id: undefined,
  period1DayAfter: undefined,
  period1DayBefore: undefined,
  period1Enabled: undefined,
  period1End: undefined,
  period1Name: undefined,
  period1Start: undefined,
  period2DayAfter: undefined,
  period2DayBefore: undefined,
  period2Enabled: undefined,
  period2End: undefined,
  period2Name: undefined,
  period2Start: undefined,
  period3DayAfter: undefined,
  period3DayBefore: undefined,
  period3Enabled: undefined,
  period3End: undefined,
  period3Name: undefined,
  period3Start: undefined,
  period4DayAfter: undefined,
  period4DayBefore: undefined,
  period4Enabled: undefined,
  period4End: undefined,
  period4Name: undefined,
  period4Start: undefined,
  period5DayAfter: undefined,
  period5DayBefore: undefined,
  period5Enabled: undefined,
  period5End: undefined,
  period5Name: undefined,
  period5Start: undefined,
  period6DayAfter: undefined,
  period6DayBefore: undefined,
  period6Enabled: undefined,
  period6End: undefined,
  period6Name: undefined,
  period6Start: undefined,
  period7DayAfter: undefined,
  period7DayBefore: undefined,
  period7Enabled: undefined,
  period7End: undefined,
  period7Name: undefined,
  period7Start: undefined,
  period8DayAfter: undefined,
  period8DayBefore: undefined,
  period8Enabled: undefined,
  period8End: undefined,
  period8Name: undefined,
  period8Start: undefined,
}) {
}
